import type { FC } from 'react'

import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'

import { getCheckboxIcon } from './helpers'

import './styles.scss'

const PolicyListItem: FC<{
  id: number
  name: string
  description: string
  customerHeadName: string
  vendorName: string
  coverAmount: number | null
  currency: string | null
  selectedPolicyIds: number[] | null
  searchQuery?: string
  isMultipleChoice?: boolean
  onPolicySelect: (id: number) => void
}> = ({
  id,
  name,
  description,
  coverAmount,
  vendorName,
  customerHeadName,
  currency,
  selectedPolicyIds,
  searchQuery,
  isMultipleChoice,
  onPolicySelect,
}) => {
  const translate = useTranslation()
  const { formatNumber } = useFormattedNumberWithCurrency()
  const isSelected = Boolean(selectedPolicyIds?.includes(id))
  const Icon = getCheckboxIcon({ isSelected, isMultipleChoice })

  return (
    <tr onClick={() => onPolicySelect(id)} className={`${isSelected ? 'selected' : ''}`}>
      <td className="check-mark">
        <Icon />
      </td>

      <td>
        <Highlight
          pattern={searchQuery}
          text={`${customerHeadName ? translate('Global') : translate('Local')}: ${name}`}
        />
      </td>

      <td className="is-mobile-hidden">
        <Highlight pattern={searchQuery} text={description} />
      </td>

      <td className="is-mobile-hidden">
        <Highlight pattern={searchQuery} text={vendorName} />
      </td>

      <td className="is-mobile-hidden number">
        <Highlight
          pattern={searchQuery}
          text={formatNumber({ amount: coverAmount || 0, currency })}
        />
      </td>
    </tr>
  )
}

export default PolicyListItem
